export const districtList = [
    "Aligarh",
"Agra",
 "Allahabad",
 "Ambedkar Nagar",
 "Amethi",
 "Amroha",
 "Auraiya",
 "Azamgarh",
 "Baghpat",
 "Bahraich",
 "Ballia",
 "Balrampur",
 "Banda",
 "Barabanki",
 "Bareilly",
 "Basti",
 "Bhadohi",
 "Bijnor",
 "Budaun",
 "Bulandshahr",
 "Chandauli",
 "Chitrakoot",
 "Deoria",
 "Etah",
 "Etawah",
 "Faizabad",
 "Farrukhabad",
 "Fatehpur",
 "Firozabad",
 "Gautam Buddha Nagar",
 "Ghaziabad",
 "Ghazipur",
 "Gonda",
 "Gorakhpur",
 "Hamirpur",
 "Hapur",
 "Hardoi",
 "Hathras",
 "Jalaun",
 "Jaunpur",
 "Jhansi",
 "Kannauj",
 "Kanpur Dehat",
 "Kanpur Nagar",
 "Kasganj",
 "Kaushambi",
 "Kushinagar",
 "Lakhimpur Kheri",
 "Lalitpur",
 "Lucknow",
 "Maharajganj",
 "Mahoba",
 "Mainpuri",
 "Mathura",
 "Mau",
 "Meerut",
 "Mirzapur",
 "Moradabad",
 "Muzaffarnagar",
 "Pilibhit",
 "Pratapgarh",
 "Raebareli",
 "Rampur",
 "Saharanpur",
 "Sambhal",
 "Sant Kabir Nagar",
 "Shahjahanpur",
 "Shamli",
 "Shravasti",
 "Siddharth Nagar",
 "Sitapur",
 "Sonbhadra",
 "Sultanpur",
 "Unnao",
 "Varanasi"]